<template>
  <v-card class="d-flex pa-4 flex-column" outlined>
    <TableSearchFilter
      :search="filterValue"
      @search="updateSearch" 
      @showType="showType"
      :filters="filterType"
    />
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :customTopActions="true"
      :expandedItem="true"
      item-key="_id"
    >
      <template v-slot:expanded-item="{ item }">
        <td :colspan="headers.length">
          <div class="row sp-details">
            <div class="col-12 mb-4">
              <strong>Data</strong>
              <div v-if="['UPDATE', 'CREATE'].includes(item.action) && Array.isArray(item.content_raw)" class="table-container">
                <table class="data-table">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Field</th>
                      <th>Old Value</th>
                      <th>New Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, idx) in item.content_raw" :key="idx">
                      <td>{{ idx + 1 }}</td>
                      <td>{{ row.field }}</td>
                      <td>{{ row.old_value || 'Null' }}</td>
                      <td>{{ row.new_value || 'Null' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="json-text">
                {{ item.content_raw ? JSON.stringify(item.content_raw, null, 2) : 'Null' }}
                <v-btn
                  icon
                  small
                  class="clipboard-icon"
                  @click="copyToClipboard(item.content_raw)"
                >
                  <v-icon size="18">mdi-clipboard-multiple</v-icon>
                </v-btn>
              </div>
            </div>

            <!-- Server Hostname -->
            <div class="col-12 mb-4">
              <strong>Server Hostname</strong>
              <div class="json-text">
                {{ item.hostname }}
                <v-btn
                  icon
                  small
                  class="clipboard-icon"
                  @click="copyToClipboard(item.hostname)"
                >
                  <v-icon size="18">mdi-clipboard-multiple</v-icon>
                </v-btn>
              </div>
            </div>

            <!-- Error Description -->
            <div class="col-12 mb-4">
              <strong>Error Description</strong>
              <div class="json-text">
                {{ item.error_description || 'Null' }}
                <v-btn
                  icon
                  small
                  class="clipboard-icon"
                  @click="copyToClipboard(item.error_description)"
                >
                  <v-icon size="18">mdi-clipboard-multiple</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </td>
      </template>

      <template v-slot:custom="{ item }">
        {{ item.uri || '-' }}
      </template>

      <template v-slot:custom_status="{ item }">
        <v-chip
          :color="item.status === 'success' ? '#4CAF50' : (item.status === 'failed' ? '#F44336' : '#9E9E9E')"
          text-color="white"
          small
        >
          {{ item.status }}
        </v-chip>
      </template>
    </TableView>
    </v-card>
    
  </template>

<script>
import auditTrailMerchantMixin from "@components/system-log/audit-trail/portal-merchant/auditTrailMerchantMixin";


export default {
  mixins: [  auditTrailMerchantMixin ],
  components: {
    TableSearchFilter: () => import("@components/@drontVue/components/SearchFilter/TableSearchFilter.vue"),
    TableView: () => import("@components/@drontVue/components/Table/TableView.vue"),
  },

};
</script>

<style scoped>
.button-expand {
  padding: 0 !important; 
}
::v-deep .expand_action {
  padding: 0 !important;
  text-align: center;
}
.grid-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px; 
  padding: 5px;
}

.grid-layout div {
  margin-bottom: 10px; 
}
.json-text {
  position: relative;
  background-color: #eeeeee;
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.8rem;
  font-weight: bold;
  color: #333333;
  padding: 8px;
  padding-right: 45px;
  border-radius: 4px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  min-height: 30px;
  word-break: break-all;
}
.clipboard-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1;
  background-color: transparent;
  color: #555;
  transition: color 0.3s;
}

.clipboard-icon:hover {
  color: #000;
}
.sp-details {
  padding: 10px;
  margin: 10px 0 0 15px;
}
.table-container {
  background-color: #eeeeee;
  padding: 16px;
  border-radius: 4px;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 0.9rem;
  border: 2px solid #378595;
}
.data-table th {
  background-color: #378595  !important;
  color: white !important;
  padding: 12px 8px !important;
  text-align: left !important;
  font-weight: 600 !important;
  border-bottom: 1px solid #0d47a1 !important;
}
.data-table td {
  padding: 10px 8px;
  border-bottom: 1px solid #378595;
  color: #333;
}
.data-table th:first-child,
.data-table td:first-child {
  width: 50px;
  text-align: center;
}
.data-table tbody tr:hover {
  background-color: #e0e0e0;
}
</style>
